import React from "react"
import { useIntl } from "react-intl"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { ConsumerUnreadMessagesDot } from "#/pages/consumer/messages/ConsumerUnreadMessagesDot"
import { NavItemWrapper } from "./MainNavigation"
import { UnreadMessagesDot } from "./UnreadMessagesDot"

export function MessagesNavItem({ onClick }: { onClick: () => void }): JSX.Element {
  const intl = useIntl()
  const { data: programFlags } = useMemberProgramFlags()

  // Mirrors the split in MessagesRoute: consumers get the packaged messages experience, everyone
  // else the original. Unlike the route there is no loading gate — both dots read the same
  // `["threads"]` cache entry, so falling back to the host dot while the flags resolve costs
  // nothing and cannot flash (the dot renders nothing until threads load either way).
  const unreadDot = programFlags?.isConsumer ? <ConsumerUnreadMessagesDot /> : <UnreadMessagesDot />

  return (
    <NavItemWrapper
      link="/messages"
      onClick={onClick}
      text={intl.formatMessage({ defaultMessage: "Messages" })}
      extraNavIndicator={unreadDot}
    />
  )
}
